import React, { createContext } from 'react';
import { GoalType } from '../utils/apiRoutes';

// Define the Target type - matches WordPress API prepare_target() response
export interface Target {
  id: number;
  title: string;
  title_render: string;
  acf: {
    [key: string]: any; // ACF fields can vary
    index?: string;
    status?: string | number;
    select_goal?: number | number[];
  };
  computed?: {
    target_semaphore_status?: string | number;
    target_status_score?: number | null;
    target_trend_status?: string | number;
    target_trend_score?: number | null;
  };
  goal_ids?: number[];
  featured_image_url?: string;
}

// Context shape
interface TargetsContextType {
  targets: Target[];
  loading: boolean;
  fetchTargetsByGoal: (goalId: number, goalType: GoalType) => Promise<void>;
  fetchAllTargetsByType: (goalType: GoalType) => Promise<void>;
  fetchSingleTarget: (targetId: number, goalType: GoalType) => Promise<Target | null>;
  clearCache: () => void;
}

// Default value
const defaultContextValue: TargetsContextType = {
  targets: [],
  loading: true,
  fetchTargetsByGoal: async () => {},
  fetchAllTargetsByType: async () => {},
  fetchSingleTarget: async () => null,
  clearCache: () => {},
};

// Create and export the context
const TargetsContext = createContext<TargetsContextType>(defaultContextValue);

export { TargetsContext, type TargetsContextType };
